import { render, staticRenderFns } from "./Directory.vue?vue&type=template&id=18dfa3e1&scoped=true&"
import script from "./Directory.vue?vue&type=script&lang=ts&"
export * from "./Directory.vue?vue&type=script&lang=ts&"
import style0 from "./Directory.vue?vue&type=style&index=0&id=18dfa3e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfa3e1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VIcon,VList,VListItemGroup,VRow,VSkeletonLoader,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18dfa3e1')) {
      api.createRecord('18dfa3e1', component.options)
    } else {
      api.reload('18dfa3e1', component.options)
    }
    module.hot.accept("./Directory.vue?vue&type=template&id=18dfa3e1&scoped=true&", function () {
      api.rerender('18dfa3e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/directory/components/Directory.vue"
export default component.exports